import DeckImage from './DeckImage';
import FoodCategory from './FoodCategory';
import Offers from './Offers';
import Sponsor from './Sponsor';
import ETA from './Eta';
import Brand from './BrandName';
import ProductName from './ProductName';
import ReviewsAndRatings from './ReviewsAndRatings';
import SkuShimmer from './SKUDeckShimmers';
import CTA from './CtaOnDeck';
import PackSelector from './PackSelector';
import Pricing from './Pricing';
import SKUDeck from './SKUDeck';
import BBstarPrice from './BBstarPrice';
import OfferCommunication from './OfferCommunication';
import OfferEntryPoint from './OfferEntryPoint';
import DivWrapper from './SKUDivWrapper';
import HeadingWrapper from './SKUHeadingWrapper';
import CitrusAd from './CitrusAd';
import ProductSelection from './ProductSelection';
import DeckHeadingLink from './DeckHeadingLink';

SKUDeck.Image = DeckImage;
SKUDeck.FoodCategory = FoodCategory;
SKUDeck.Offers = Offers;
SKUDeck.Sponsor = Sponsor;
SKUDeck.ETA = ETA;
SKUDeck.BrandName = Brand;
SKUDeck.ProductName = ProductName;
SKUDeck.ReviewsAndRatings = ReviewsAndRatings;
SKUDeck.PackSelector = PackSelector;
SKUDeck.CTA = CTA;
SKUDeck.Pricing = Pricing;
SKUDeck.BBstarPrice = BBstarPrice;
SKUDeck.OfferCommunication = OfferCommunication;
SKUDeck.OfferEntryPoint = OfferEntryPoint;
SKUDeck.DivWrapper = DivWrapper;
SKUDeck.HeadingWrapper = HeadingWrapper;
SKUDeck.CitrusAd = CitrusAd;
SKUDeck.ProductSelection = ProductSelection;
SKUDeck.DeckHeadingLink = DeckHeadingLink;

export default SKUDeck;
export { SkuShimmer };
